<template>
  <ReassuranceItem has-link @click="openObsoleteComputerModal">
    <template #icon>
      <IconPower class="h-24 w-24 md:h-32 md:w-32" />
    </template>
    <template #title>
      {{ i18n(translations.title) }}
    </template>

    <template #subtitle> {{ i18n(translations.subtitle) }}</template>
  </ReassuranceItem>
  <ObsoleteComputerModal />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { openModal } from '@ds/components/ModalBase'
import { IconPower } from '@ds/icons/IconPower'

import { MODAL_NAMES } from '~/scopes/product/constants'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemObsoleteComputer.translations'
import ObsoleteComputerModal from './components/ObsoleteComputerModal/ObsoleteComputerModal.vue'

const i18n = useI18n()

function openObsoleteComputerModal() {
  openModal(MODAL_NAMES.OBSOLETE_COMPUTER)
}
</script>
